'use client';

import React from 'react';
import { LucideIcon } from 'lucide-react';
import { Card } from '@/components/ui/Card';
import { StaggerChildren } from '@/components/animations/StaggerChildren';
import { motion } from 'framer-motion';

interface Feature {
  id?: string | number;
  icon: LucideIcon | string;
  title: string;
  description: string;
}

interface ServiceFeaturesProps {
  features: Feature[];
  className?: string;
}

export function ServiceFeatures({ features, className }: ServiceFeaturesProps) {
  return (
    <StaggerChildren staggerDelay={0.1}>
      <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 ${className || ''}`}>
        {features.map((feature, index) => {
          const Icon = feature.icon;
          return (
            <motion.div
              key={feature.id || index}
              variants={{
                hidden: { opacity: 0, y: 20 },
                visible: { opacity: 1, y: 0 },
              }}
            >
              <Card variant="hover">
                <div className="p-8 flex flex-col h-full">
                  <div className="mb-4 inline-flex">
                    <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center">
                      {typeof Icon === 'string' ? (
                        <span className="text-primary text-2xl">{Icon}</span>
                      ) : (
                        <Icon className="w-7 h-7 text-primary" />
                      )}
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-foreground mb-3">{feature.title}</h3>
                  <p className="text-muted text-sm flex-grow">{feature.description}</p>
                </div>
              </Card>
            </motion.div>
          );
        })}
      </div>
    </StaggerChildren>
  );
}
